<template>
    <div>
    <!-- Modal -->
        <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Resultado del cálculo</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body modal-body-calculate">
                        <p>Flete(USD): <strong>{{ getFixedValue(totalFlete) }}</strong></p>
                        <p>Impuestos/CIF(USD): <strong>{{ getFixedValue(tax) }}</strong></p>
                        <p>Combustible(USD): <strong>{{ getFixedValue(gasoline) }}</strong></p>
                        <p>Seguro(USD): <strong>{{ getFixedValue(insurance) }}</strong></p>
                        <p>Manejo(USD): <strong>{{ getFixedValue(management) }}</strong></p>
                        <h2 class="text-center">Total: <span class="green">${{ getFixedValue(totalResult) }}</span></h2>
                    </div>
                    <div class="modal-footer">
                        <button data-toggle="modal" data-target="#exampleModal">OK</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-container" ref="contactForm">
            <button class="open-modal-hidden" data-toggle="modal" data-target="#exampleModal"></button>
            <form @submit.prevent="calculate">
                <div class="form-row">
                    <div class="col-md-12">
                        <p class="form-heading">¿Que desea hacer? Escoja una opción</p>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-md-12">
                        <div class="btn-group" role="group" aria-label="Basic example">
                            <button :class="{'active' : !articleCalculate}" @click="articleCalculate = false" type="button" class="btn">Cotizar</button>
                            <button :class="{'active' : articleCalculate}" @click="articleCalculate = true; articleLink = false" type="button" class="btn">Calcular</button>
                        </div>
                    </div>
                </div>
                <h2>Cotizar</h2>
                <div class="form-row" v-if="!articleCalculate">
                    <div class="col-md-12">
                        <p>Datos personales para el envío de la información</p>
                    </div>
                </div>
                <div class="form-row" v-if="!articleCalculate">
                    <div class="col-md-6">
                        <input v-model="emailMessage.name" type="text" v-validate=" !articleCalculate ? 'required' : null" class="form-control" name="name" :class="{ 'is-invalid': submitted && errors.has('name') }" id="inputName" placeholder="Nombre">
                        <div v-if="submitted && errors.has('name')" class="invalid-feedback">{{ errors.first('name') }}</div>
                    </div>
                    <div class="col-md-6">
                        <input v-model="emailMessage.lastName" type="text" v-validate=" !articleCalculate ? 'required' : null" class="form-control" name="lastName" :class="{ 'is-invalid': submitted && errors.has('lastName') }" id="inputLastName" placeholder="Apellido">
                        <div v-if="submitted && errors.has('lastName')" class="invalid-feedback">{{ errors.first('lastName') }}</div>
                    </div>
                </div>
                <div class="form-row" v-if="!articleCalculate">
                    <div class="col-md-12">
                        <input v-model="emailMessage.email" type="email" v-validate=" !articleCalculate ? 'required|email' : null" class="form-control" name="email" :class="{ 'is-invalid': submitted && errors.has('email') }" id="inputEmail" placeholder="Email">
                        <div v-if="submitted && errors.has('email')" class="invalid-feedback">{{ errors.first('email') }}</div>
                    </div>
                </div>
                <div class="form-row" v-if="!articleCalculate">
                    <div class="col-md-12">
                        <p>¿Qué información tiene del artículo?</p>
                    </div>
                    <div class="col-md-12 advice-message">
                        <span>Puede ser el link del artículo o la descripción completa.</span>
                    </div>
                </div>
                <div class="form-row" v-if="articleCalculate">
                    <div class="col-md-12">
                        <p>Datos del artículo</p>
                    </div>
                    <div class="col-md-12 advice-message">
                        <span>Categorías, medidas, peso y monto de factura</span>
                    </div>
                </div>
                <div class="form-group" v-if="!articleCalculate">
                    <div class="form-check">
                        <input v-model="articleLink" class="form-check-input" type="checkbox" id="articleLink">
                        <label class="form-check-label" for="articleLink">
                            Link del artículo
                        </label>
                    </div>
                </div>
                <div class="form-row" v-if="articleLink && !articleCalculate">
                    <div class="col-md-12">
                        <input v-model="emailMessage.link" class="form-control" v-validate="articleLink ? {required: true, url: 'require_protocol'} : null" name="articleLink" :class="{ 'is-invalid': submitted && errors.has('articleLink') }" placeholder="www.amazon.com/artículo">
                        <div v-if="submitted && errors.has('articleLink')" class="invalid-feedback">{{ errors.first('articleLink') }}</div>
                    </div>
                </div>
                <div class="form-group" v-if="!articleCalculate">
                    <div class="form-check">
                        <input v-model="articleData" class="form-check-input" type="checkbox" id="articleDescription">
                        <label class="form-check-label" for="articleDescription">
                            Datos del artículo
                        </label>
                    </div>
                </div>
                <div v-if="articleData || articleCalculate">
                    <div class="form-group">
                        <label class="form-label" for="exampleFormControlSelect1">Tipo de artículo</label>
                        <select @change="emailMessage.articleLabel = setTypeName($event)" v-validate=" !articleLink ? 'required' : null" :class="{ 'is-invalid': submitted && errors.has('arancel') }" class="form-control" id="arancel" name="arancel">
                            <option value="">Seleccione uno...</option>
                            <option value="0.1300" label="Accesorios de Impresora (13.00%)">Accesorios de Impresora (13.00%)</option>
                            <option value="0.1300" label="Adaptador (13.00%)">Adaptador (13.00%)</option>
                            <option value="0.2995" label="Adornos (29.95%)">Adornos (29.95%)</option>
                            <option value="0.1413" label="Alarma (14.13%)">Alarma (14.13%)</option>
                            <option value="0.2995" label="Alfombra (29.95%)">Alfombra (29.95%)</option>
                            <option value="0.4278" label="Amortiguadores (42.78%)">Amortiguadores (42.78%)</option>
                            <option value="0.1413" label="Amplificador (14.13%)">Amplificador (14.13%)</option>
                            <option value="0.4927" label="Amplificador (con grabador) (49.27%)">Amplificador (con grabador) (49.27%)</option>
                            <option value="0.1413" label="Antena (14.13%)">Antena (14.13%)</option>
                            <option value="0.2995" label="Anteojos (29.95%)">Anteojos (29.95%)</option>
                            <option value="0.2430" label="Aros de Bicicleta (24.30%)">Aros de Bicicleta (24.30%)</option>
                            <option value="0.4278" label="Aros de Carro y Moto (42.78%)">Aros de Carro y Moto (42.78%)</option>
                            <option value="0.4278" label="Arrancador (42.78%)">Arrancador (42.78%)</option>
                            <option value="0.2995" label="Articulos para Fiesta (29.95%)">Articulos para Fiesta (29.95%)</option>
                            <option value="0.4927" label="Aspiradora (49.27%)">Aspiradora (49.27%)</option>
                            <option value="0.1413" label="Auricular de Telefono (14.13%)">Auricular de Telefono (14.13%)</option>
                            <option value="0.4238" label="Baterias (laptop y celular) (42.38%)">Baterias (laptop y celular) (42.38%)</option>
                            <option value="0.1300" label="Bicicleta (CIF menos de $1000) (13.00%)">Bicicleta (CIF menos de $1000) (13.00%)</option>
                            <option value="0.2995" label="Bicicleta (CIF$1000) (29.95%)">Bicicleta (CIF$1000) (29.95%)</option>
                            <option value="0.2995" label="Binoculares (29.95%)">Binoculares (29.95%)</option>
                            <option value="0.1413" label="Bocina (pito) (14.13%)">Bocina (pito) (14.13%)</option>
                            <option value="0.2430" label="Bola (de futbol o ejercicios) (24.30%)">Bola (de futbol o ejercicios) (24.30%)</option>
                            <option value="0.1413" label="Bomba de Aceite o Agua (14.13%)">Bomba de Aceite o Agua (14.13%)</option>
                            <option value="0.1978" label="Bombillos (19.78%)">Bombillos (19.78%)</option>
                            <option value="0.4278" label="Bujias (42.78%)">Bujias (42.78%)</option>
                            <option value="0.2995" label="Cables Electricos (29.95%)">Cables Electricos (29.95%)</option>
                            <option value="0.1300" label="Calculadora (13.00%)">Calculadora (13.00%)</option>
                            <option value="0.1413" label="Cámara de Video y Fotografica (14.13%)">Cámara de Video y Fotografica (14.13%)</option>
                            <option value="0.2430" label="Cana de Pescar (24.30%)">Cana de Pescar (24.30%)</option>
                            <option value="0.1413" label="Cargador (14.13%)">Cargador (14.13%)</option>
                            <option value="0.2900" label="Casco de Seguridad (conductores) (29.00%)">Casco de Seguridad (conductores) (13.00%)</option>
                            <option value="0.2995" label="Case para CPU (29.95%)">Case para CPU (29.95%)</option>
                            <option value="0.1413" label="CD's (14.13%)">CD's (14.13%)</option>
                            <option value="0.1300" label="Celulares (13.00%)">Celulares (13.00%)</option>
                            <option value="0.4278" label="Cinturon (42.78%)">Cinturon (42.78%)</option>
                            <option value="0.4278" label="Cluth (42.78%)">Cluth (42.78%)</option>
                            <option value="0.2995" label="Coche de bebe (29.95%)">Coche de bebe (29.95%)</option>
                            <option value="0.2995" label="Colchon (29.95%)">Colchon (29.95%)</option>
                            <option value="0.1300" label="Computadora (Portatil / Escritorio) (13.00%)">Computadora (Portatil / Escritorio) (13.00%)</option>
                            <option value="0.4927" label="Consola de Video Juegos (49.27%)">Consola de Video Juegos (49.27%)</option>
                            <option value="0.1413" label="Control Remoto (14.13%)">Control Remoto (14.13%)</option>
                            <option value="0.2995" label="Cortinas (29.95%)">Cortinas (29.95%)</option>
                            <option value="0.1300" label="Disco Duro (13.00%)">Disco Duro (13.00%)</option>
                            <option value="0.4927" label="Diskman o walkman (49.27%)">Diskman o walkman (49.27%)</option>
                            <option value="0.2430" label="DVD's (24.30%)">DVD's (24.30%)</option>
                            <option value="0.4927" label="Electrodomésticos (49.27%)">Electrodomésticos (49.27%)</option>
                            <option value="0.4927" label="Equipo de Sonido (49.27%)">Equipo de Sonido (49.27%)</option>
                            <option value="0.4927" label="Equipo para Karaoke (49.27%)">Equipo para Karaoke (49.27%)</option>
                            <option value="0.2430" label="Filtro de Aceite/Aire (24.30%)">Filtro de Aceite/Aire (24.30%)</option>
                            <option value="0.1413" label="Filtro de Agua (14.13%)">Filtro de Agua (14.13%)</option>
                            <option value="0.2995" label="Fluorescente (29.95%)">Fluorescente (29.95%)</option>
                            <option value="0.1413" label="Fotocopiadora (14.13%)">Fotocopiadora (14.13%)</option>
                            <option value="0.1413" label="Fuente de Poder (14.13%)">Fuente de Poder (14.13%)</option>
                            <option value="0.1413" label="Gata Hidraulica (14.13%)">Gata Hidraulica (14.13%)</option>
                            <option value="0.2995" label="Gorras (29.95%">Gorras (29.95%)</option>
                            <option value="0.2995" label="Griferia (29.95%)">Griferia (29.95%)</option>
                            <option value="0.2995" label="Guitarra Acustica (29.95%)">Guitarra Acustica (29.95%)</option>
                            <option value="0.2430" label="Guitarra Electrica (24.30%)">Guitarra Electrica (24.30%)</option>
                            <option value="0.2430" label="Herramientas (24.30%)">Herramientas (24.30%)</option>
                            <option value="0.4927" label="Home Teather (49.27%)">Home Teather (49.27%)</option>
                            <option value="0.1300" label="Impresora (13.00%)">Impresora (13.00%)</option>
                            <option value="0.2995" label="Instrumentos musicales (29.95%)">Instrumentos musicales (29.95%)</option>
                            <option value="0.4927" label="Ipod y MP3, MP4 Player (49.27%)">Ipod y MP3, MP4 Player (49.27%)</option>
                            <option value="0.2995" label="Joyeria/Bisuteria (29.95%)">Joyeria/Bisuteria (29.95%)</option>
                            <option value="0.2995" label="Juego de Meza (29.95%)">Juego de Meza (29.95%)</option>
                            <option value="0.2995" label="Juguetes (29.95%)">Juguetes (29.95%)</option>
                            <option value="0.2995" label="Lampara (29.95%)">Lampara (29.95%)</option>
                            <option value="0.4927" label="Lector de DVD / CD (49.27%)">Lector de DVD / CD (49.27%)</option>
                            <option value="0.1978" label="Lente de Contacto (19.78%)">Lente de Contacto (19.78%)</option>
                            <option value="0.1413" label="Lente para Camara Fotografica (14.13%)">Lente para Camara Fotografica (14.13%)</option>
                            <option value="0.0100" label="Libros (1.00%)">Libros (1.00%)</option>
                            <option value="0.2430" label="Llantas para Vehiculo (24.30%)">Llantas para Vehiculo (24.30%)</option>
                            <option value="0.1300" label="Llave Maya (13.00%)">Llave Maya (13.00%)</option>
                            <option value="0.1413" label="Luces de Carro (14.13%)">Luces de Carro (14.13%)</option>
                            <option value="0.2995" label="Maletines, salveques, bolsos, estuches, fajas (29.95%)">Maletines, salveques, bolsos, estuches, fajas (29.95%)</option>
                            <option value="0.2995" label="Manguera (29.95%)">Manguera (29.95%)</option>
                            <option value="0.1413" label="Maquina de Coser, Soldar (14.13%)">Maquina de Coser, Soldar (14.13%)</option>
                            <option value="0.1300" label="Memoria (13.00%)">Memoria (13.00%)</option>
                            <option value="0.1413" label="Microscopio (14.13%)">Microscopio (14.13%)</option>
                            <option value="0.4927" label="Mixer (49.27%)">Mixer (49.27%)</option>
                            <option value="0.4278" label="Molduras para Vehiculo (42.78%)">Molduras para Vehiculo (42.78%)</option>
                            <option value="0.1300" label="Monitor de computadora (13.00%)">Monitor de computadora (13.00%)</option>
                            <option value="0.2995" label="Muebles (29.95%)">Muebles (29.95%)</option>
                            <option value="0.4278" label="Mufla (42.78%)">Mufla (42.78%)</option>
                            <option value="0.2995" label="Ollas y Sartenes (de Metal) (29.95%)">Ollas y Sartenes (de Metal) (29.95%)</option>
                            <option value="0.2430" label="Palos de Golf (24.30%)">Palos de Golf (24.30%)</option>
                            <option value="0.2995" label="Panos (29.95%)">Panos (29.95%)</option>
                            <option value="0.2430" label="Papel (24.30%)">Papel (24.30%)</option>
                            <option value="0.1978" label="Parabrisas (19.78%)">Parabrisas (19.78%)</option>
                            <option value="0.1413" label="Parlantes (14.13%)">Parlantes (14.13%)</option>
                            <option value="0.4278" label="Partes de carrocería (42.78%)">Partes de carrocería (42.78%)</option>
                            <option value="0.2430" label="Patines (Ruedas/Hielo) (24.30%)">Patines (Ruedas/Hielo) (24.30%)</option>
                            <option value="0.2995" label="Pelucas (29.95%)">Pelucas (29.95%)</option>
                            <option value="0.1413" label="Pinon (14.13%)">Pinon (14.13%)</option>
                            <option value="0.4927" label="Plancha de Pelo (49.27%)">Plancha de Pelo (49.27%)</option>
                            <option value="0.2995" label="Platos de Ceramica (29.95%)">Platos de Ceramica (29.95%)</option>
                            <option value="0.2995" label="Posters (29.95%)">Posters (29.95%)</option>
                            <option value="0.1300" label="Procesador (13.00%)">Procesador (13.00%)</option>
                            <option value="0.4927" label="Proyector de video (49.27%)">Proyector de video (49.27%)</option>
                            <option value="0.4927" label="Quemador de CD/DVD (49.27%)">Quemador de CD/DVD (49.27%)</option>
                            <option value="0.4878" label="Rack para Carro (48.78%)">Rack para Carro (48.78%)</option>
                            <option value="0.4278" label="Radiador (42.78%)">Radiador (42.78%)</option>
                            <option value="0.4927" label="Radio de Carro (49.27%)">Radio de Carro (49.27%)</option>
                            <option value="0.1300" label="Radio de Comunicacion (13.00%)">Radio de Comunicacion (13.00%)</option>
                            <option value="0.2430" label="Raqueta (24.30%)">Raqueta (24.30%)</option>
                            <option value="0.4927" label="Rasuradora eléctrica (49.27%)">Rasuradora eléctrica (49.27%)</option>
                            <option value="0.6800" label="Refrigerador (68.00%)">Refrigerador (68.00%)</option>
                            <option value="0.2995" label="Relojes (29.95%)">Relojes (29.95%)</option>
                            <option value="0.4927" label="Reproductor de Blu-Ray (49.27%)">Reproductor de Blu-Ray (49.27%)</option>
                            <option value="0.1413" label="Repuestos de motor (14.13%)">Repuestos de motor (14.13%)</option>
                            <option value="0.1978" label="Retrovisor (19.78%)">Retrovisor (19.78%)</option>
                            <option value="0.1413" label="Romana (14.13%)">Romana (14.13%)</option>
                            <option value="0.2995" label="Ropa (29.95%)">Ropa (29.95%)</option>
                            <option value="0.1300" label="Router (13.00%)">Router (13.00%)</option>
                            <option value="0.2995" label="Sabanas (29.95%)">Sabanas (29.95%)</option>
                            <option value="0.4927" label="Secadoras de Pelo (49.27%)">Secadoras de Pelo (49.27%)</option>
                            <option value="0.1300" label="Silla de bebe para Carro (13.00%)">Silla de bebe para Carro (13.00%)</option>
                            <option value="0.2995" label="Sleeping Bag (29.95%)">Sleeping Bag (29.95%)</option>
                            <option value="0.1300" label="Software (13.00%)">Software (13.00%)</option>
                            <option value="0.2995" label="Sombrilla (29.95%)">Sombrilla (29.95%)</option>
                            <option value="0.2995" label="Sombrilla para Fotografia (29.95%)">Sombrilla para Fotografia (29.95%)</option>
                            <option value="0.4278" label="Suspension de Carro (42.78%)">Suspension de Carro (42.78%)</option>
                            <option value="0.4278" label="Suspension de Moto (42.78%)">Suspension de Moto (42.78%)</option>
                            <option value="0.2430" label="Tabla de Surf (24.30%)">Tabla de Surf (24.30%)</option>
                            <option value="0.1300" label="Tableta electrónica (13.00%)">Tableta electrónica (13.00%)</option>
                            <option value="0.1300" label="Tarjeta de video o sonido (13.00%)">Tarjeta de video o sonido (13.00%)</option>
                            <option value="0.1300" label="Tarjetas Madre (Computadoras) (13.00%)">Tarjetas Madre (Computadoras) (13.00%)</option>
                            <option value="0.2430" label="Teclado Musical (24.30%)">Teclado Musical (24.30%)</option>
                            <option value="0.1300" label="Teclado para Computadora (13.00%)">Teclado para Computadora (13.00%)</option>
                            <option value="0.1300" label="Teléfonos (13.00%)">Teléfonos (13.00%)</option>
                            <option value="0.4927" label="Televisor (49.27%)">Televisor (49.27%)</option>
                            <option value="0.2995" label="Tienda de Campana (29.95%)">Tienda de Campana (29.95%)</option>
                            <option value="0.2995" label="Tripode (29.95%)">Tripode (29.95%)</option>
                            <option value="0.1413" label="Valvulas (14.13%)">Valvulas (14.13%)</option>
                            <option value="0.2995" label="Vaso de Vidrio (29.95%)">Vaso de Vidrio (29.95%)</option>
                            <option value="0.2430" label="Ventiladores para Computadora (24.30%)">Ventiladores para Computadora (24.30%)</option>
                            <option value="0.1413" label="Video Juegos (14.13%)">Video Juegos (14.13%)</option>
                            <option value="0.4927" label="Video Monitor (entrada HDMI) (49.27%)">Video Monitor (entrada HDMI) (49.27%)</option>
                            <option value="0.2995" label="Zapatos (29.95%)">Zapatos (29.95%)</option>
                        </select>
                        <div v-if="submitted && errors.has('arancel')" class="invalid-feedback">{{ errors.first('arancel') }}</div>
                    </div>
                    <label class="form-label">Dimensiones</label>
                    <div class="form-row">
                        <div class="form-group col-md-3">
                            <label>Medida en</label>
                            <select v-model="typeM" class="form-control">
                                <option value="cm">Cm</option>
                                <option value="pulg">Pulg</option>
                                <option value="pies">Pies</option>
                            </select>
                        </div>
                        <div class="form-group col-md-3">
                            <label>Largo</label>
                            <input @keypress="isNumber($event)" v-model="largo" v-validate=" !articleLink ? 'required' : null" type="text" name="largo" class="form-control" :class="{ 'is-invalid': submitted && errors.has('largo') }" placeholder="00.0">
                            <div v-if="submitted && errors.has('largo')" class="invalid-feedback">{{ errors.first('largo') }}</div>
                        </div>
                        <div class="form-group col-md-3">
                            <label>Ancho</label>
                            <input @keypress="isNumber($event)" v-model="ancho" v-validate=" !articleLink ? 'required' : null" type="text" name="ancho" class="form-control" :class="{ 'is-invalid': submitted && errors.has('ancho') }" placeholder="00.0">
                            <div v-if="submitted && errors.has('ancho')" class="invalid-feedback">{{ errors.first('ancho') }}</div>
                        </div>
                        <div class="form-group col-md-3">
                            <label>Alto</label>
                            <input @keypress="isNumber($event)" v-model="alto" v-validate=" !articleLink ? 'required' : null" type="text" name="alto" class="form-control" :class="{ 'is-invalid': submitted && errors.has('alto') }" placeholder="00.0">
                            <div v-if="submitted && errors.has('alto')" class="invalid-feedback">{{ errors.first('alto') }}</div>
                        </div>
                    </div>
                    <label class="form-label">Peso total</label>
                    <div class="form-row">
                        <div class="form-group col-md-3">
                            <label>Medida en</label>
                            <select v-model="typeK" class="form-control">
                                <option value="kilo">Kilo</option>
                                <option value="libras">Libras</option>
                            </select>
                        </div>
                        <div class="form-group col-md-3">
                            <label>Peso</label>
                            <input @keypress="isNumber($event)" v-model="kilo" v-validate=" !articleLink ? 'required' : null" name="peso" type="text" class="form-control" :class="{ 'is-invalid': submitted && errors.has('peso') }" placeholder="00.0">
                            <div v-if="submitted && errors.has('peso')" class="invalid-feedback">{{ errors.first('peso') }}</div>
                        </div>
                        <!--<div class="form-group col-md-3">
                            <label>№ unidades</label>
                            <input type="text" class="form-control" placeholder="00.0">
                        </div>-->
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label class="form-label">¿Tiene el monto de la factura? En dólares</label>
                            <input @keypress="isNumber($event)" v-model="monto" v-validate=" !articleLink ? 'required' : null" type="text" class="form-control" name="monto" id="monto" placeholder="000.00" :class="{ 'is-invalid': submitted && errors.has('monto') }">
                            <div v-if="submitted && errors.has('monto')" class="invalid-feedback">{{ errors.first('monto') }}</div>
                        </div>
                    </div>
                </div>

                <button v-if="!articleCalculate" type="submit" class="default-button default-button-form">Enviar</button>
                <button v-if="articleCalculate" type="submit" class="default-button default-button-form">Calcular</button>
                
                <p v-if="!articleCalculate" class="advice-message">La cotización será enviada a su correo electrónico</p>
            </form>
        </div>
    </div>
</template>

<script>

/* eslint-disable */
export default {
  context: 'quotation context',
  name: 'Quotation',

  data: () => {
    return {
        articleLink: true,
        articleData: false,
        articleCalculate: false,
        submitted: false,
        totalResult: '',
        tax: '',
        arancel: '',
        typeM: 'cm',
        typeK: 'kilo',
        monto: '',
        largo: '',
        ancho: '',
        alto: '',
        kilo: '',
        convert: '',
        insurance: '',
        vinsurance: 0.50,
        carGasoline: 0.20,
        cif: '',
        peso2: '',
        management: '',
        
        //tax
        tarifas: [6,8,12,16,20,24,28,32,36,40,44,48,52,56,60,64,68,72,76,80,86],
        dimenciones: '',
        precioPeso: '',
        peso: '',
        totalFlete: '',
        gasoline: '',
        //the varible divdem have value of the division for get the dimensions.
        divdem: 6000,
        piesConversion :  30.48,
        pulgadasConversion: 2.54,
        emailMessage: {
            name: '',
            lastName: '',
            email: '',
            formName: "cotizar",
            subjectMail: 'Cotización de usuario CRBOX',
            bodyMail: '',
            link: '',
            articleLabel: ''
        }
    }
  },
  watch: {
        articleLink: function(val) {
          this.articleData = !val;
        },
        articleData: function(val) {
          this.articleLink = !val;
        }
  },
  methods: {
    setTypeName(e) {
            e.target.options[e.target.selectedIndex].selected = true
            this.arancel = e.target.options[e.target.selectedIndex].value
            return e.target.options[e.target.selectedIndex].text;
    },
    calculate() {
        this.submitted = true;
        this.$validator.validate().then(valid => {
            if (valid) {
                if(this.articleCalculate){
                    let largo = 0;
                    let ancho = 0;
                    let alto = 0;
                    if(this.typeM=="pulg"){
                        largo = this.largo * this.pulgadasConversion;
                        ancho = this.ancho * this.pulgadasConversion;
                        alto = this.alto * this.pulgadasConversion;
                    }
                    else if(this.typeM=="pies"){
                        largo = this.largo * this.piesConversion;
                        ancho = this.ancho * this.piesConversion;
                        alto = this.alto * this.piesConversion;
                    }
                    else{
                        largo = this.largo;
                        ancho = this.ancho;
                        alto = this.alto;
                    }
                    //calculate the dimenciones for the package.
                    this.dimenciones = (largo * ancho * alto) / this.divdem;
                    //round the total of dimenciones.
                    this.dimenciones = parseFloat(this.dimenciones);
                    //convert of lib to kg if typeK is the same of libras
                    if(this.typeK=="libras"){
                        this.convert = this.kilo / 2.2;
                    }
                    else{
                        this.convert = this.kilo;
                    }
                    /*********Convierte a kilos****************/
                    this.convert=parseFloat(this.convert);
                   
                    if(this.dimenciones > this.convert){
                        this.peso = this.dimenciones;
                    }
                    else if(this.dimenciones < this.convert){
                        this.peso = this.convert;
                    }
                    this.peso2 = this.peso;

                    var entero = Math.floor(this.peso);
                    var decimal = this.peso - entero;

                    if(entero!=0){
                        if(decimal>=0.2){
                            this.peso = Math.ceil(this.peso);
                        }
                        else if (decimal <= 0.19999999999999999999999){
                            this.peso = Math.floor(this.peso);
                        }
                    }
                    else{
                        this.peso = entero;
                    }
                    if(this.peso <= 20){
                        this.precioPeso = this.tarifas[this.peso];
                    }
                    else if(this.peso > 20 && this.peso <= 100){
                        
                        this.precioPeso = this.tarifas[20];
                        this.peso = this.peso - 20;
                        var precioPes = (this.peso * 3);
                        this.precioPeso = parseFloat(this.precioPeso) + parseFloat(precioPes);

                    }
                    else if(this.peso > 100){
                        this.precioPeso = this.tarifas[20];

                        this.peso = this.peso - 100;
                        var precioPeso1 = (this.peso * 2.3);

                        this.peso2 = 80;
                        var precioPeso2 = this.peso2 * 3;
 
                        this.precioPeso = parseFloat(precioPeso1) + parseFloat(precioPeso2) + parseFloat(this.precioPeso);
                    }

                    //get freight(flete) total
                    if(this.precioPeso >= this.dimenciones){

                        this.totalFlete = this.precioPeso;

                    }else{

                        this.totalFlete = this.dimenciones;

                    }
                    //total flete
                    this.totalFlete = parseFloat(this.totalFlete);
                    //Get tax gasoline
                    this.gasoline = this.totalFlete * this.carGasoline;
                    //este es cargo por conbustible
                    
                    //Get insurance(seguro)
                    //insurance es seguro
                    if( this.monto < 100){

                        this.insurance = this.vinsurance;

                    }else{

                        this.insurance = Math.floor(this.monto/100);
                        this.insurance= parseFloat(this.insurance)*parseFloat(this.vinsurance);
                    }
                    
                    //Get tax or CIF
                    this.cif=parseFloat(this.monto)+parseFloat(this.totalFlete)+parseFloat(this.insurance);
                    
                    if(this.cif > 1000){
                        this.$notify({
                            group: 'notifications',
                            type: 'error',
                            title: 'Monto máximo superado',
                            text: 'El Monto a calcular no puede superar el costo CIF de $1000. Debe solicitar cotización a ventas@crbox.cr.',
                            duration: 7000,
                            speed: 1000
                        });
                        return; 
                    }
                     
                    var tax = this.cif * this.arancel;
                    
                    // Este es impuestos/cif
                    this.tax = tax;
                    
                    //calculo del manejo                   
                    if(this.cif < 20){
                        this.management=1.5;
                    }else if(this.cif <= 30){
                        this.management = 3.5;
                    }else if(this.cif <= 50){
                        this.management = 5.5;
                    }else if(this.cif <= 100 ){
                        this.management = 7;
                    }else if(this.cif <= 200){
                        this.management = 14;
                    }else if(this.cif <= 500){
                        this.management = 35;
                    }else if(this.cif <= 1000){
                        this.management = 45;
                    }
 
                    this.totalResult = parseFloat(this.totalFlete) + parseFloat(this.tax) + parseFloat(this.gasoline) + parseFloat(this.insurance) + parseFloat(this.management);
                    document.querySelector('.open-modal-hidden').click();
                    return;
                }
                else if(this.articleLink || this.articleData){
                    let loader = this.$loading.show({
                        container: this.$refs.contactForm
                    });
                    var email = {};
                    email.subjectMail = this.emailMessage.subjectMail;
                    email.formName = this.emailMessage.formName;
                    if(this.articleLink){
                        email.bodyMail = `<p><strong>De:</strong> ${this.emailMessage.name} ${this.emailMessage.lastName}</p>
                        <p><strong>Email:</strong> ${this.emailMessage.email}</p>
                        <p><strong>Link de articulo para cotizar: </strong>
                        ${this.emailMessage.link}</p>`; 
                    }
                    else if(this.articleData){
                        email.bodyMail = `<p><strong>De:</strong> ${this.emailMessage.name} ${this.emailMessage.lastName}</p>
                        <p><strong>Email:</strong> ${this.emailMessage.email}</p>
                        <p><strong>Datos de articulo para cotizar</strong></p>
                        <p><strong>Articulo: </strong>${this.emailMessage.articleLabel}</p>
                        <h3><strong>Dimensiones</strong></h3>
                        <p><strong>Medida en: </strong>${this.typeM}</p>
                        <p><strong>Largo: </strong>${this.largo}</p>
                        <p><strong>Ancho: </strong>${this.ancho}</p>
                        <p><strong>Alto: </strong>${this.alto}</p>
                        <h3><strong>Peso total</strong></h3>
                        <p><strong>Medida en: </strong>${this.typeK}</p>
                        <p><strong>Peso: </strong>${this.kilo}</p>
                        <p><strong>Monto de la factura: </strong>$ ${this.monto}</p>`;
                    }
                    this.$http.post(window.location.origin + '/wp-json/crbox/v1/sendEmail', email)
                    .then((response) => {
                        if(response.data){
                            this.$notify({
                                group: 'notifications',
                                type: 'success',
                                title: 'Correo enviado',
                                text: 'Correo enviado satisfactoriamente!',
                                duration: 4000,
                                speed: 1000
                            });
                        }else{
                            this.$notify({
                                group: 'notifications',
                                type: 'error',
                                title: 'Correo',
                                text: 'Ocurrió un error al enviar el correo',
                                duration: 4000,
                                speed: 1000
                            });
                        }
                        loader.hide();
                    })
                    .catch(()=>{
                        this.$notify({
                            group: 'notifications',
                            type: 'error',
                            title: 'Correo',
                            text: 'Ocurrió un error al enviar el correo',
                            duration: 4000,
                            speed: 1000
                        });
                        loader.hide();
                    })
                }
            }
        });
      },
      getFixedValue(value) {
          return parseFloat(value).toFixed(2);
      },
      isNumber: function(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
            evt.preventDefault();;
        } else {
            return true;
        }
      }
      


    /*validateEmptyFields: function(event, el) {
        event.preventDefault();
        var inputs = el.querySelectorAll('input');
        inputs.forEach((input) => {
            if(input.value == '' || input.value == undefined){
                var checkIfErrorExist = input.parentNode.querySelectorAll('.input-empty-error');
                if(checkIfErrorExist.length == 0){
                    var error = document.createElement('p');
                    error.innerHTML = '*Este campo es requerido';
                    error.classList.add('input-empty-error');
                    input.parentNode.appendChild(error);
                }
            }
            else{
                var error =  input.parentNode.querySelectorAll('.input-empty-error');
                if (typeof(error) != 'undefined' && error != null)
                {
                    input.parentNode.childNodes.forEach((child) => {
                        if(child.classList.contains('input-empty-error')){
                            input.parentNode.removeChild(child);
                        }
                    })
                }
            }
        });
    }*/
  }
}
</script>
